import { html } from 'lit';
const SignOut =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8 2.25A2.75 2.75 0 0 0 5.25 5v14A2.75 2.75 0 0 0 8 21.75h5A2.75 2.75 0 0 0 15.75 19v-1.5a.75.75 0 0 0-1.5 0V19c0 .69-.56 1.25-1.25 1.25H8c-.69 0-1.25-.56-1.25-1.25V5c0-.69.56-1.25 1.25-1.25h5c.69 0 1.25.56 1.25 1.25v1.5a.75.75 0 0 0 1.5 0V5A2.75 2.75 0 0 0 13 2.25zm10.03 6.22a.75.75 0 1 0-1.06 1.06l1 1 .72.72H11a.75.75 0 0 0 0 1.5h7.69l-.72.72-1 1a.75.75 0 1 0 1.06 1.06l1-1 2-2a.75.75 0 0 0 0-1.06l-2-2z" clip-rule="evenodd"/>
  </svg>
`;
export default SignOut;
